import { z } from "zod";

import { organisationSchema } from "./organisation.type";
import { questionnaireSchema } from "./questionnaire.type";

export const organisationWithQuestionnaireIdsSchema = organisationSchema.extend({
  questionnaireIds: z.array(questionnaireSchema.shape.id)
});

export type OrganisationWithQuestionnaireIds = z.infer<typeof organisationWithQuestionnaireIdsSchema>;
